import { charVariants, containerVariants } from "@/constants/banner-constants";
import { motion } from "framer-motion";

export function SplitText({ text, className }) {
  return (
    <motion.span
      className={`inline-flex flex-wrap ${className}`}
      variants={containerVariants}
      initial="hidden"
      animate="show"
      aria-label={text}
    >
      {text.split("").map((ch, i) => (
        <motion.span
          key={i}
          variants={charVariants}
          className="inline-block"
          style={{ transformOrigin: "bottom center" }}
        >
          {ch === " " ? "\u00A0" : ch}
        </motion.span>
      ))}
    </motion.span>
  );
}
